import { t } from '@hefe/i18n';
import { User } from '@hefe/models';
import {
  currentUserIsAdminSelector,
  currentUserSelector,
  UsersSlice,
} from '@hefe/store';
import { formatDatabaseDate } from '@hefe/utils';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../store/store';
import CustomForm from '../../../core/components/form/custom-form';

interface AddEditTerminationFormProps {
  user: User;
}

export default function AddEditTerminationForm(
  props: AddEditTerminationFormProps
) {
  const dispatch = useAppDispatch();
  const currentUser = useSelector(currentUserSelector);
  const currentUserIsAdmin = useSelector(currentUserIsAdminSelector);
  const [isSaving, setSaving] = useState(false);

  const submit = (values: any, resetForm: any) => {
    setSaving(true);
    dispatch(
      UsersSlice.createUserTermination({
        termination_date: formatDatabaseDate(values.termination_date, false),
        reason: values.reason,
        user_id: props.user.id,
      })
    )
      .unwrap()
      .catch(() => null)
      .finally(() => setSaving(false));
  };

  return (
    <CustomForm
      key={`add-edit-termination-${props.user.id}`}
      loading={isSaving}
      fields={[
        {
          name: 'termination_date',
          label: t('termination.form.fields.termination_date'),
          placeholder: t('select'),
          rules: [
            {
              required: true,
              message: t('errors.required'),
            },
          ],
          type: 'date',
        },
        {
          name: 'reason',
          label: t('termination.form.fields.reason'),
          placeholder: t('select'),
          rules: [],
          type: 'text',
        },
      ]}
      onSubmit={submit}
    />
  );
}
